<template>
  <div class="class-statistics">
    <a-breadcrumb class="bread">
      <a-breadcrumb-item>
        <a-icon type="home" />
      </a-breadcrumb-item>
      <a-breadcrumb-item>
        <router-link :to="{name: 'NutritionMonitorIndex'}">营养监测</router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item class="current">{{currentClass.name}}</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="statistics">
      <div class="dame">
        <div class="item date">日期：<a-date-picker :allowClear='false' size="large" v-model="selectedDate" @change="onDateChange" :disabled-date="disabledDate" /></div>
        <div class="item meal">
          餐次：<a-select
            :value='selectedMeal'
            @change="onMealChange"
            style="width: 120px"
            size="large"
          >
            <a-select-option v-for="(item,key) in mealTypes" :value="key" :key="key">{{item}}</a-select-option>
          </a-select>
        </div>
      </div>
      <div class="total-item">
        <div class="item to">
          <div class="tenu">
            <div class="text"><span>总人数</span></div>
            <div class="num">
              <span class="big">{{currentClass.statistics?currentClass.statistics.total:0}}</span>
              <!-- <span class="divider">/</span>
              <span class="small">17个班级</span> -->
            </div>
          </div>
        </div>
        <div class="item no">
          <div class="tenu">
            <div class="text"><span>未用餐</span></div>
            <div class="num">
              <span class="big">{{currentClass.statistics?currentClass.statistics.total - currentClass.statistics.nDined:0}}</span><span class="divider">/</span
              ><span class="small">{{100 - dinedRate}}%</span>
            </div>
            <div class="progress">
              <a-progress
                :percent="100 - dinedRate"
                :strokeWidth="3"
                strokeColor="#e4b207"
                :show-info="false"
              />
            </div>
          </div>
        </div>
        <div class="item yes">
          <div class="yi">
            <div class="tenu">
              <div class="text"><span>已用餐</span></div>
              <div class="num">
                <span class="big">{{currentClass.statistics?currentClass.statistics.nDined:0}}</span><span class="divider">/</span
                ><span class="small">{{dinedRate}}%</span>
              </div>
              <div class="progress">
                <a-progress
                  :percent="dinedRate"
                  :strokeWidth="3"
                  strokeColor="#2fae6f"
                  :show-info="false"
                />
              </div>
            </div>
          </div>
          <div class="intake">
            <div class="it">
              <div class="tn">
                <div class="icon">
                  <img src="~@/assets/images/icon-school9.png" />
                </div>
                <div class="te">正常摄入</div>
                <div class="nu">{{currentClass.statistics?currentClass.statistics.nHealth:0}}</div>
              </div>
            </div>
            <div class="it">
              <div class="icon">
                <img src="~@/assets/images/icon-school3.png" />
              </div>
              <div class="tn">
                <div class="te">摄入不足</div>
                <div class="nu fprimary">{{currentClass.statistics?currentClass.statistics.nInsufficient:0}}</div>
              </div>
            </div>
            <div class="it">
              <div class="icon">
                <img src="~@/assets/images/icon-school2.png" />
              </div>
              <div class="tn">
                <div class="te">摄入超量</div>
                <div class="nu fred">{{currentClass.statistics?currentClass.statistics.nExcess:0}}</div>
              </div>
            </div>
          </div>
          <div class="chart">
            <div id="calssdetailchartid" style="width: 100px;height:100px;"></div>
            <div class="text">健康(<b>{{currentClass.statistics?currentClass.statistics.healthRate:50}}%</b>)</div>
          </div>
        </div>
      </div>
    </div>
    <student-list></student-list>
    <record-meal-modal @onRecordSuccess="refreshData()"></record-meal-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import studentList from '@/components/nutritionMonitor/StudentList'
import recordMealModal from '@/components/nutritionMonitor/RecordMealModal'
import moment from 'moment'
import apis from '@/business/apis'
import { mealTypes } from '@/business/enums'
export default {
  inject: ['eventBus'],
  components: {
    studentList,
    recordMealModal
  },
  data () {
    return {
      selectedDate: null,
      mealTypes
    }
  },
  computed: {
    ...mapState('nutrition', [
      'currentClass',
      'selectedMeal'
    ]),
    ...mapState('school', [
      'currentSchool'
    ]),
    dinedRate () {
      return this.currentClass.statistics && this.currentClass.statistics.total > 0 ? Math.round(this.currentClass.statistics.nDined / this.currentClass.statistics.total * 100) : 50
    }
  },
  methods: {
    ...mapActions('nutrition', [
      'saveCurrClass',
      'saveSelectedMeal'
    ]),
    initChart () {
      const unHealth = this.currentClass.statistics ? this.currentClass.statistics.nExcess + this.currentClass.statistics.nInsufficient : 0
      const health = this.currentClass.statistics ? this.currentClass.statistics.nDined - unHealth : 0
      const chart = this.$echarts.init(document.getElementById('calssdetailchartid'))
      const colorList = ['#45c284', '#f1cc5d']
      const option = {
        tooltip: {
          trigger: 'item',
          formatter:
            "<b style='font-size:18px;color:#ffce0a;font-family:DIN Alternate;'>{c}</b><span style='color:#ffce0a;'>人</span>({d}%)"
        },
        series: [
          {
            type: 'pie',
            radius: ['85%', '100%'],
            avoidLabelOverlap: false,
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  return colorList[params.dataIndex]
                }
              }
            },
            data: [{ value: health }, { value: unHealth }]
          }
        ]
      }
      chart.setOption(option)
    },
    async onDateChange (data) {
      this.eventBus.$emit('nutrition-class-date-change', data)
      const query = '?schoolId=' + this.currentSchool._id + '&date=' + this.selectedDate.unix() + '&groupId=' + this.currentClass._id + '&meal=' + this.selectedMeal
      const respose = await this.$http.get(apis.nutrition.oneClassStatistics + query)
      const temp = {
        date: this.selectedDate,
        name: this.currentClass.name,
        _id: this.currentClass._id,
        manual_record_meal: this.currentClass.manual_record_meal,
        school_id: this.currentClass.school_id,
        statistics: respose.body
      }
      // temp.statistics.excessRate = 0
      // temp.statistics.insufficientRate = 0
      temp.statistics.nHealth = 0
      temp.statistics.healthRate = 50
      if (temp.statistics.nDined > 0) {
        // temp.statistics.excessRate = Math.round(temp.statistics.nExcess / temp.statistics.nDined * 100)
        // temp.statistics.insufficientRate = Math.round(temp.statistics.nInsufficient / temp.statistics.nDined * 100)
        temp.statistics.nHealth = temp.statistics.nDined - temp.statistics.nInsufficient - temp.statistics.nExcess
        temp.statistics.healthRate = Math.round(temp.statistics.nHealth / temp.statistics.nDined * 100)
      }
      await this.saveCurrClass(temp)
      this.initChart()
    },
    onMealChange (data) {
      this.saveSelectedMeal(data)
      this.onDateChange(this.selectedDate)
    },
    refreshData () {
      this.onDateChange(this.selectedDate)
    },
    disabledDate (date) {
      const now = moment()
      const d = this.appIsDemo ? 90 : 15
      if (date <= now && date > now.subtract(d, 'days')) return false
      return true
    }
  },
  mounted () {
    this.selectedDate = this.currentClass.date ? moment(this.currentClass.date) : moment()
    if (!this.selectedMeal) {
      this.saveSelectedMeal()
    }
    this.initChart()
  }
}
</script>

<style lang="less">
.class-statistics {
  .bread {
    margin-top: -4px;
    margin-bottom: 20px;
    .current {
      font-size: 20px;
    }
  }
  .statistics {
    border: 1px solid #e7e7eb;
    background: #fff;
    border-radius: 6px;
    padding: 16px;
    .dame {
      margin-bottom: 16px;
      display: flex;
      .item {
        margin-right: 16px;
      }
    }
    .total-item {
      display: flex;
      text-align: center;
      .item {
        background: #f6f8f9;
        height: 120px;
        overflow: hidden;
        margin-right: 12px;
        padding: 16px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        &:last-child {
          margin-right: 0;
        }
        &.to {
          width: 160px;
          background: #ebf3fe;
          .text {
            span {
              &::after {
                background: #1b80ec;
              }
            }
          }
          .num {
            .small {
              color: #1b80ec;
            }
          }
        }
        &.no {
          width: 160px;
          background: #f9f4e6;
          .text {
            span {
              &::after {
                background: #e4b207;
              }
            }
          }
          .num {
            .small {
              color: #e4b207;
            }
          }
          .ant-progress-inner {
            background-color: #e6e0cf;
          }
        }
        &.yes {
          background: #eaf9f1;
          flex: 1;
          display: flex;
          align-items: center;
          .text {
            span {
              &::after {
                background: #2fae6f;
              }
            }
          }
          .num {
            .small {
              color: #2fae6f;
            }
          }
          .ant-progress-inner {
            background-color: #d3e3da;
          }
          .yi {
            width: 128px;
          }
          .intake {
            flex: 1;
            display: flex;
            line-height: 1;
            .it {
              flex: 1;
              border-left: 1px solid #d7ebe0;
              &:last-child {
                border-right: 1px solid #d7ebe0;
              }
              .icon {
                width: 36px;
                height: 36px;
                margin: 0 auto 6px;
                img {
                  width: 100%;
                }
              }
              .tn {
                .te {
                  font-size: 13px;
                }
                .nu {
                  margin-top: 6px;
                  font-size: 24px;
                  font-weight: bold;
                }
              }
            }
          }
          .chart {
            position: relative;
            margin-left: 16px;
            .text {
              position: absolute;
              left: 0;
              right: 0;
              top: 50%;
              margin-top: -8px;
              text-align: center;
              font-size: 14px;
            }
          }
        }
        .tenu {
          line-height: 1;
          .text {
            span {
              padding-left: 12px;
              position: relative;
              &::after {
                content: "";
                position: absolute;
                left: 0;
                top: 50%;
                width: 8px;
                height: 8px;
                margin-top: -4px;
                border-radius: 50%;
              }
            }
          }
          .num {
            margin-top: 10px;
            .big {
              font-size: 28px;
              font-weight: bold;
            }
            .small {
              font-size: 14px;
            }
            .divider {
              margin: 0 4px;
            }
          }
          .progress {
            margin: 0 auto -8px;
            width: 90px;
          }
        }
      }
    }
  }
  .fili {
    margin-top: 24px;
    border: 1px solid #e7e7eb;
    background: #fff;
    border-radius: 6px;
    padding: 0 16px;
    > .title {
      padding-top: 16px;
      display: flex;
      align-items: center;
      h1 {
        flex: 1;
        font-size: 20px;
      }
      .fun {
        display: flex;
        align-items: center;
        .search {
          .ant-input {
            height: 44px;
          }
          .anticon {
            font-size: 18px;
          }
        }
        .button {
          display: flex;
          align-items: center;
          .ant-btn {
            min-width: 80px;
            margin-left: 16px;
          }
        }
      }
    }
    .list {
      .table {
        margin: 16px 0;
        .avna {
          .avatar {
            margin-right: 2px;
          }
        }
        .sp {
          margin: 0 2px;
        }
      }
    }
  }
}
.checkin-model {
  .tag {
    .ant-tag {
      padding: 4px 7px;
      border-radius: 3px;
      font-size: 13px;
      background: #f0f0f0;
      border: 1px solid #f0f0f0;
      .anticon {
        margin-right: -4px;
        margin-left: 4px;
      }
    }
  }
  .tips {
    color: #999;
    margin-bottom: -16px;
    font-size: 12px;
    line-height: 1.4;
  }
}
</style>
